import { Controller } from '@hotwired/stimulus';

export class FocusStealController extends Controller {
  static targets = ['element'];

  steal(event) {
    if (event?.params?.ignoreFields && event.target !== this.elementTarget && event.target.closest?.('input, select, textarea, [contenteditable="true"]')) return;

    this.elementTarget.focus();
  }
}
